<div class="desktop-cover" *ngIf="!success">
    <h1>Reset password</h1>

    <div class="info" *ngIf="!success && !keyMissing">
        <p>Choose a new password</p>
    </div>

    <form *ngIf="!success && !keyMissing" name="form" role="form" (ngSubmit)="finishReset()" #passwordForm="ngForm">
        <div class="form-group">
            <label class="form-control-label" for="password">New password :</label>
            <input type="password" class="form-control" id="password" name="password" #passwordInput="ngModel"
                   placeholder=""
                   [(ngModel)]="resetAccount.password" minlength=4 maxlength=50 required>
        </div>
        <div class="form-group">
            <label class="form-control-label" for="confirmPassword">Confirmation :</label>
            <input type="password" class="form-control" id="confirmPassword" name="confirmPassword"
                   #confirmPasswordInput="ngModel"
                   placeholder=""
                   [(ngModel)]="confirmPassword" minlength=4 maxlength=50 required>
        </div>

        <dln-button [type]="'submit'" [isDisabled]="passwordForm.form.invalid"
                    [isLoading]="isLoading" [isLoadingLabel]="'Sending request...'"
                    [label]="'Reset'" [icon]="'dln-icon-key'">
        </dln-button>
    </form>

    <dln-alert [type]="'error'" *ngIf="keyMissing">
        <strong>The password reset key is missing. <br>Please check your email and open reset password link</strong>
    </dln-alert>

    <dln-alert [type]="'error'" *ngIf="error">
        Your password couldn't be reset. <br>Remember a password request is only valid for 24 hours.
    </dln-alert>

    <dln-alert [type]="'error'" *ngIf="doNotMatch">
        The password and its confirmation do not match!
    </dln-alert>

</div>

<div class="desktop-cover" *ngIf="success">
    <div class="success-request">
        <h1>Success</h1>
        <i class="dln-icon-tic-success"></i>
        <div class="msg"><strong>Your password has been reset.</strong><br>Please log in</div>
        <dln-back-button [url]="'/'" desktopLabel="Back to log-in" mobileLabel="Back to login-in"></dln-back-button>
    </div>
</div>
